<template>
  <v-form ref="formCartao" v-model="cartaoValid" lazy-validation class="mt-4">
    <v-card class="mt-4">
      <v-card-title>
        <strong>Preencha os dados do cartão</strong>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 md12>
              <v-text-field
                autofocus
                :disabled="isUpdating"
                v-model="cartao.numero"
                label="Número do cartão"
                v-mask="'################'"
                hint="Obrigatório"
                :rules="[
                  validacao.cartao_numero == false || validacao.cartao_numero,
                  (value) => !!value || 'Obrigatório.',
                  (value) => (value && value.length > 13) || 'Número inválido'
                ]"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.cartao_numero = false"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8>
              <v-text-field
                :disabled="isUpdating"
                v-model="cartao.nome"
                label="Nome impresso no cartão"
                maxlength="100"
                hint="Obrigatório"
                :rules="[
                  validacao.cartao_nome == false || validacao.cartao_nome,
                  (value) => !!value || 'Obrigatório.',
                  (value) => (value && value.length > 2) || 'Preencha o nome no cartão'
                ]"
                color="blue-grey lighten-2"
                @change="
                  validacao.cartao_nome = false;
                  cartao.nome = removeEspeciais(cartao.nome);
                "
                autocomplete="disabled"
                :name="Math.random()"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2>
              <v-text-field
                :disabled="isUpdating"
                v-model="cartao.validade"
                label="Validade"
                v-mask="'##/####'"
                hint="Obrigatório"
                :rules="[
                  validacao.cartao_validade == false || validacao.cartao_validade,
                  (value) => !!value || 'Obrigatório.',
                  (value) => (value && value.length == 7) || 'Deve conter mês/ano (MM/AAAA)',
                  (value) => valida_competencia_futura(value)
                ]"
                @change="validacao.cartao_validade = false"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2>
              <v-text-field
                :disabled="isUpdating"
                v-model="cartao.cvv"
                label="CVV"
                v-mask="'###'"
                hint="Obrigatório"
                :rules="[
                  validacao.cartao_cvv == false || validacao.cartao_cvv,
                  (value) => !!value || 'Obrigatório.',
                  (value) => (value && value.length == 3) || 'Deve conter 3 dígitos numéricos'
                ]"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.cartao_cvv = false"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import util from "../util";
export default {
  props: {
    validacao: {},
    isUpdating: { type: Boolean, default: false }
  },
  data() {
    return {
      cartao: {},

      cartaoValid: true
    };
  },
  methods: {
    validar() {
      this.$refs.formCartao.validate();
    },
    retornaCartao() {
      if (!this.$refs.formCartao.validate()) {
        return {};
      } else {
        return this.cartao;
      }
    },
    removeEspeciais(text) {
      return util.removeEspeciais(text).toUpperCase();
    },
    valida_competencia_futura(text) {
      if (!util.valida_competencia_futura(text)) {
        return "Validade inválida";
      } else {
        return true;
      }
    }
  }
};
</script>
